<i18n
  src="@/locales/views/organization/process/packing/list_processes.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      {{ module_name }}
    </h1>
  </div>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="harvest_process in harvest_processes"
        :key="harvest_process.id"
      >
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowProcess(harvest_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ harvest_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-crate-apple flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ harvest_process.number_harvested_batches }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/process/packing/list_processes.js";

export default {
  name: "AEProductionBasicContainerExportListProcesses",
  components: {},
  props: {
    organization_id: { required: true }
  },
  data() {
    return {
      load_data_general: false,
      harvest_processes: []
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response = await Requester.fetchHarvestProcesses(
        this.organization_id
      );
      this.harvest_processes = response.data;
      this.load_data_general = true;
    },
    goToShowProcess: function (harvest_process) {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          organization_id: this.organization_id,
          harvest_process_id: harvest_process.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.fetchAgroExporterProcesses())
    );
  }
};
</script>
